function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  className: "st2",
  id: "cross"
}, React.createElement("g", {
  className: "st0"
}, React.createElement("line", {
  className: "st1",
  x1: 112.5,
  x2: 401,
  y1: 112.5,
  y2: 401
}), React.createElement("line", {
  className: "st1",
  x1: 401,
  x2: 112.5,
  y1: 112.5,
  y2: 401
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "cross_copy"
}, React.createElement("path", {
  d: "M268.064,256.75l138.593-138.593c3.124-3.124,3.124-8.189,0-11.313c-3.125-3.124-8.189-3.124-11.314,0L256.75,245.436   L118.157,106.843c-3.124-3.124-8.189-3.124-11.313,0c-3.125,3.124-3.125,8.189,0,11.313L245.436,256.75L106.843,395.343   c-3.125,3.125-3.125,8.189,0,11.314c1.562,1.562,3.609,2.343,5.657,2.343s4.095-0.781,5.657-2.343L256.75,268.064l138.593,138.593   c1.563,1.562,3.609,2.343,5.657,2.343s4.095-0.781,5.657-2.343c3.124-3.125,3.124-8.189,0-11.314L268.064,256.75z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "512px",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    version: 1.1,
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/cross.82c9db8c.svg";
export { SvgComponent as ReactComponent };